import React from 'react';
import PageLayout from '../../components/PageLayout';
import { CCard, CCardHeader, CCardTitle, CCol, CLabel, CLink, CRow } from '@coreui/react';
import _t from 'counterpart';
import { useGetSetting } from '../generalSettings/hooks';
import { extractErrorMessage } from '../../helpers';
import QueryDataRenderer from '../../components/QueryDataRenderer';
import toast from 'react-hot-toast';
import VoIPProviderPage from './VoipProviderConfigurationPage';

const VoipProvidersPage = () => {
  const providerQuery = useGetSetting('VOIP_PROVIDER', 'voip-page-provider', {
    onError: (error: any) => {
      toast.error(extractErrorMessage(error));
    },
  });

  const provider = providerQuery.data;
  const isError = Boolean(providerQuery.error);
  const isLoading = providerQuery.isLoading;

  return (
    <PageLayout title="VoIP providers">
      <QueryDataRenderer isError={isError} isLoading={isLoading} onRefetch={providerQuery.refetch}>
        {provider === '' && (
          <CRow>
            <CCol>
              <CCard>
                <CCardHeader>
                  <CCardTitle>{_t('voip.voip-provider-disabled')}</CCardTitle>
                  <CLabel>{_t('voip.enable-voip-on-page')}</CLabel>
                  <CLink href="/integrations"> {_t('global.here')}</CLink>
                </CCardHeader>
              </CCard>
            </CCol>
          </CRow>
        )}
        {provider && <VoIPProviderPage provider={String(provider)} />}
      </QueryDataRenderer>
    </PageLayout>
  );
};

export default React.memo(VoipProvidersPage);
